module.exports = __webpack_public_path__ + "static/media/event.ce9638c9.svg";